import HeaderTop from "../components/header/HeaderTop.jsx";
import Menu from "../components/menu/Menu.jsx";
import Header from "../components/header/Header.jsx";
import HomeContent from "../components/home/HomeContent.jsx";
import Footer from "../components/footer/Footer.jsx";

export default function Home() {
    return (
        <>
            <HeaderTop/>
            <Menu/>
            <Header/>
            <HomeContent/>
            <Footer/>
        </>
    )
}

